const QA_STATUS = Object.freeze({
  TO_ANSWER: 'to_answer',
  TO_VALIDATE: 'to_validate',
  VALIDATED: 'validated',
})

export { QA_STATUS }
